import { LightningElement, api, wire } from "lwc";
import { c as classNames } from "tds/chunk_index";
import { logger } from "@devforce/trailhead-client-logger";
import { LabelsAdapter } from "common/labelsAdapter";
import { assignedSlotNames } from "common/slot";
import { attrToBool } from "common/helpers";

var data$7 = { close: "Schließen" };
data$7.close;

var data$6 = { close: "Close" };
data$6.close;

var data$5 = { close: "Cerrar" };
data$5.close;

var data$4 = { close: "Fermer" };
data$4.close;

var data$3 = { close: "閉じる" };
data$3.close;

var data$2 = { close: "닫기" };
data$2.close;

var data$1 = { close: "Fechar" };
data$1.close;

var data = { close: "关闭" };
data.close;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$7,
  en: data$6,
  esMX: data$5,
  fr: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

class modal extends LightningElement {
  @api assistiveText = null;
  @api disableClose = null;
  @api dismissOnClickOutside = "";
  @api fullHeight = null;
  @api open = null;
  @api size = null;
  slots = "";
  initialOverflowValue = "";
  @wire(LabelsAdapter, {
    locales,
  })
  labels = null;

  connectedCallback() {
    if (!this._disableClose) {
      window.addEventListener("keydown", this.handleKeyDown);
    }
  }

  disconnectedCallback() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }

  get isOpen() {
    return attrToBool(this.open);
  }

  get _disableClose() {
    return attrToBool(this.disableClose);
  }

  get hasNoHeading() {
    return !this.slots.includes("heading");
  }

  get dialogLabelledBy() {
    return this.assistiveText ? null : "modal-heading";
  }

  get className() {
    return classNames("modal", {
      [`modal--${this.size}`]: this.size,
      [`modal--full-height`]: attrToBool(this.fullHeight),
    });
  }

  get dialogAriaLabel() {
    return this.assistiveText || null;
  }

  handleSlotChange() {
    if (!this.isOpen) {
      return;
    }

    this.slots = assignedSlotNames(this.template).join(" ");

    if (this.hasNoHeading && !this.assistiveText) {
      logger.warn("A modal must include either a heading or assistive-text.");
    }
  }

  handleRequestClose = () => {
    this.dispatchEvent(new CustomEvent("requestclose"));
  }; // Close when user presses escape key

  handleKeyDown = (e) => {
    if (e.key === "Esc" || e.key === "Escape") {
      this.handleRequestClose();
    }
  }; // Close when user clicks outside (on backdrop)

  handleOutsideClick(e) {
    if (!attrToBool(this.dismissOnClickOutside) || this._disableClose) {
      return;
    }

    const container = this.template.querySelector(".modal__container");

    if (e.target?.contains(container)) {
      // Prevent closing if the user is highlighing text
      requestAnimationFrame(() => {
        if (!window.getSelection()?.toString()) {
          this.handleRequestClose();
        }
      });
    }
  }
}

export default modal;
